// extracted by mini-css-extract-plugin
export default {"list":"ListContent_list__vWXOa","listHeader":"ListContent_listHeader__bP02o","tableTitle":"ListContent_tableTitle__jOtGM","leftTableTitle":"ListContent_leftTableTitle__LDJWS"};